// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form-control":"textarea__form-control--3n6UL","formControl":"textarea__form-control--3n6UL","disabled":"textarea__disabled--RPkBe"};